// Extends a horizontal scroll container to the screen edge by negating ResponsiveContainer padding
export const edgeToEdgeSx = {
  mx: { xs: -2, sm: -3, md: -4, lg: -5 },
  px: { xs: 2, sm: 3, md: 4, lg: 5 },
};

// Right-edge-only fade: dims to 30% opacity over the last 24px so the edge
// reads as a soft hint rather than a hard cut or a dark shadow gradient.
export const scrollFadeMaskSx = {
  WebkitMaskImage:
    'linear-gradient(to right, black 0%, black calc(100% - 24px), rgba(0,0,0,0.3) 100%)',
  maskImage:
    'linear-gradient(to right, black 0%, black calc(100% - 24px), rgba(0,0,0,0.3) 100%)',
};
